/**
 * Parse the Error Message and returns it.
 * @param error type is APIResponseError
 * @param defaultMessage in case of any error while parsing the response. The default messgage will be returned
 * @returns actual error message or defaultMessage in case of parsing error.
 */
export function fetchAPIErrorMessage(
  error: unknown,
  defaultMessage: string,
): string {
  if (typeof error === 'object' && error != null) {
    const data = (error as any).data;
    if (data && data.hasOwnProperty('message')) {
      return data.message;
    }
  }
  return defaultMessage;
}
